import {
  IncotermPortTypeData,
  IncotermMultiPortTypeData,
  TimelineTypeData,
} from '../../../../../constants/masterData';

export const FOB_MULTI_SELECT_STRINGS = {
  selectAll: 'Select All',
  selectSomeItems: 'Please select',
  allItemsAreSelected: 'All selected',
  search: 'Search',
};

export const FOB_INCOTERM_ID = 'e0173dfd-e109-4054-8640-23d95befd326';
export const STRAITS_ROUTE_ID = 'e0173dfd-e109-4054-8640-23d95befd327';
export const FOB_LOCATION_DISPLAY_LIMIT = 3;

export const INCOTERM_PORT_OPTIONS = IncotermPortTypeData[0]?.options ?? [];
export const MULTIPORT_OPTIONS = IncotermMultiPortTypeData[0]?.options ?? [];
export const TIMELINE_OPTIONS = TimelineTypeData[0]?.options ?? [];
